export const CELL_SIZE = 32;
export const ANIMATION_DURATION = 4000;
